import React, { useState } from 'react';
import StandardQuestion from './quiz/StandardQuestion';
import RatingQuestion from './quiz/RatingQuestion';
import OrderQuestion from './quiz/OrderQuestion';
import FillInTheBlankQuestion from './quiz/FillInTheBlankQuestion';
import MessageModeration from './MessageModeration';
import { useChat } from '../modules/ChatPane';

// Factory for poll type message
// - Chooses/renders correct poll type
// - Renders moderations
export default function QuestionMessage({ showing, message, questions, room, channeltype, containerRef }) {
  const {
    message: { data },
  } = message;
  const {
    context: { content },
    setContext,
  } = useChat();

  const [isLocked, setIsLocked] = useState(false);

  const endedEarly = message.actions?.endedEarly?.true?.length > 0;

  const reportAnswer = (question, answer) => {
    reportActivityFromQuestionAndAnswer(question, answer, 'Question', content);
  };

  const setPollActive = state => {
    setContext(old => {
      return { ...old, pollActive: state };
    });
  };

  const question = questions.find(question => {
    return data.question == question.Id;
  });

  React.useEffect(() => {
    setPollActive(!isLocked);
  }, [isLocked]);

  let QuestionJSX = <></>;

  switch (question?.Type) {
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.MULTIPLECHOICE:
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.POLL:
      QuestionJSX = (
        <StandardQuestion
          message={message}
          question={question}
          endedEarly={endedEarly}
          reportAnswer={reportAnswer}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
          content={content}
        />
      );
      break;
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.SELECTMANY:
      QuestionJSX = (
        <StandardQuestion
          message={message}
          question={question}
          selectMany={true}
          endedEarly={endedEarly}
          reportAnswer={reportAnswer}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
        />
      );

      break;
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.FILLINTHEBLANK:
      QuestionJSX = (
        <FillInTheBlankQuestion
          message={message}
          question={question}
          endedEarly={endedEarly}
          reportAnswer={reportAnswer}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
        />
      );

      break;
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.ORDER:
      QuestionJSX = (
        <OrderQuestion
          message={message}
          question={question}
          endedEarly={endedEarly}
          reportAnswer={reportAnswer}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
        />
      );

      break;
    //@ts-ignore
    case QuizQuestion.QUESTION_TYPE.RATING:
      QuestionJSX = (
        <RatingQuestion
          message={message}
          showing={showing}
          question={question}
          endedEarly={endedEarly}
          reportAnswer={reportAnswer}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
        />
      );

      break;

    default:
      break;
  }

  if (!question || data.question === '') {
    !isLocked && setIsLocked(true);
    return <></>;
  }

  return (
    <div style={{ position: 'relative' }} className={`question_container`}>
      {QuestionJSX}
      <MessageModeration
        message={message}
        channeltype={channeltype}
        room={room}
        isLocked={isLocked}
        containerRef={containerRef}
      />
    </div>
  );
}
